export default {
  excursion_conflict_message: `This excursion has been modified externally. Please refresh you browser and try again.`,
};
